import { API_URL } from 'settings';
/**
 * Transforms a versioned relative API path to a complete API URL.
 *
 * `basePath` defaults to API_URL.
 *
 * For use with path builder function results (already include `/v1`, etc.).
 */
export var getApiUrl = function getApiUrl(path) {
    return "".concat(API_URL).concat(path);
};
